import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getCorporateById } from 'services/corporate.service'
import { useGlobalStore } from 'stores/global'
import { useCorporateStore } from 'stores/corporate'
import { Col, Row, Layout, Button, PageHeader } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { ROLE_ACCESS } from 'constants/accessRole'
import { mergeStringArray } from 'utilities/common'

import PermissionAccess from 'components/PermissionAccess'
const Content = Layout.Content

const DetailCorporatePage = () => {
  const param = useParams()
  const navigate = useNavigate()
  const { setPageHeader } = useGlobalStore()
  const { corporate, setCorporate } = useCorporateStore()

  useEffect(() => {
    if (param?.corporateId) {
      fetchCorporateById(param?.corporateId)
    }
  }, [param?.corporateId])

  const handleEditCorporate = () => {
    navigate(`/corporate/${param?.corporateId}/edit`)
  }

  const fetchCorporateById = async (id) => {
    try {
      const payload = await getCorporateById(id)
      if (payload.status?.code === 200) {
        setPageHeader({
          title: `${payload.data?.corporateNumber} - ${payload.data?.corporateName?.th}`,
          subTitle: undefined,
          onBack: '/corporates',
          backIcon: null,
          extra: [
            <Button key={1} type='dashed' size='large' onClick={() => navigate('/corporates')}>
              Back
            </Button>,
            <PermissionAccess roles={ROLE_ACCESS.CORPORATE_DETAIL.UPDATE} key={0}>
              <Button
                type='primary'
                shape='default'
                size='large'
                className=''
                icon={<EditOutlined />}
                onClick={() => handleEditCorporate()}
              >
                Edit Corporate
              </Button>
            </PermissionAccess>,
          ],
        })
        setCorporate({
          ...payload.data,
          corporateId: payload.data?.corporate?._id,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <div className=''>
        <Content>
          <div className='leading-7'>
            <Row gutter={16}>
              <Col span={24}>
                <PageHeader
                  title='ข้อมูลทั่วไป'
                  subTitle='Information'
                  className='lotus-page-header px-0'
                />
              </Col>
              <Col span={12}>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>ชื่อภาษาไทย</div>
                  <div className=''>{corporate?.corporateName?.th}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>ชื่อภาษาอังกฤษ</div>
                  <div className=''>{corporate?.corporateName?.en}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>ประเภท</div>
                  <div className=''>{corporate?.corporateType}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>Email</div>
                  <div className=''>{corporate?.email}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>Phone</div>
                  <div className=''>{corporate?.phoneNumber ?? 'ไม่ระบุ'}</div>
                </div>
              </Col>
              <Col span={12}>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>Vendor Code (Corporate Number)</div>
                  <div className=''>{corporate?.corporateNumber}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>Tax ID</div>
                  <div className=''>{corporate?.taxId}</div>
                </div>

                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>กลุ่มลูกค้า</div>
                  <div className=''>{corporate?.corporateGroup?.name}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>initial</div>
                  <div className=''>{corporate?.initial ?? 'ไม่ระบุ'}</div>
                </div>
              </Col>
              <Col span={24}>
                <PageHeader
                  title='ข้อมูลที่อยู่'
                  subTitle='Contact Address'
                  className='lotus-page-header px-0'
                />
              </Col>
              <Col span={24}>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>ที่อยู่</div>
                  <div className=''>{corporate?.streetAddress1}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>ที่อยู่ (เพิ่มเติม)</div>
                  <div className=''>{corporate?.streetAddress2 ?? 'ไม่ระบุ'}</div>
                </div>
                <div className='flex gap-2'>
                  <div className='w-[100px] font-bold'>สถานที่ตั้ง</div>
                  <div className=''>
                    {mergeStringArray([
                      corporate?.district,
                      corporate?.subdistrict,
                      corporate?.province,
                      corporate?.postalCode,
                    ])}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Content>
      </div>
    </>
  )
}

export default DetailCorporatePage
